<template>
    <div class="container-fluid">
        <div class="row py-3">
            <div class="designRowOrga">
                <div class="h3Organization mb-3">
                    <h3>Trainings</h3>
                </div>
                <div class="btnOrganization">
                    <div v-if="trainings.length > 0 && permissions.includes('create training')">
                        <button @click.prevent="CreateTraining">
                            Create Training
                        </button>
                    </div>
                    <div v-else></div>
                </div>
            </div>
            <div class="tab p-0 pt-3">
                <router-link class="text-decoration-none tablinks h2 m-0" to="/trainings" >Public</router-link>
                <router-link class="text-decoration-none tablinks h2 m-0 active" to="/private/trainings" >Private</router-link>
            </div>
            <div class="tabcontent">

                <div v-if="(searchFlag || statusFlag) && trainings.length === 0" class="fullInputs mb-4 pt-3">
                    <div class="twoInputs">
                        <div class="btnInsideInput" v-if="role === 'user'">
                            <input type="text" id="free_search" class="form-control" v-model="search"
                                   placeholder="Search" autocomplete="off"
                                   @input="searchTraining" maxlength="50">

                            <button @click="searchBackEndHandler(isSearch, 1)" ref="buttonSearch">
                                <img src="../../../assets/images/SearchIcon.png" alt="">
                            </button>
                        </div>
                        <div class="btnInsideInput" v-else>
                            <input type="text" id="free_search" class="form-control" v-model="search"
                                   placeholder="Search" @input="searchTraining">
                        </div>
                        <div class="getStatus">
                            <select id="statusSeacrh" v-model="status" class="form-select" @change="getTrainings">
                                <option :value="null" disabled selected>Status</option>
                                <option value="pending">Pending</option>
                                <option value="running">Running</option>
                                <option value="ended">Ended</option>
                            </select>
                        </div>
                        <div class="btnSearchAll" :style="role === 'user' ? {display: 'none'}  : {display: 'block'} ">
                            <button id="searchAll" class="form-control" ref="buttonSearch" @click="getTrainings">
                                <img src="../../../assets/images/SearchIcon.png" alt="">
                            </button>
                        </div>
                    </div>
                    <div class="oneInput">
                        <select id="filter_dates" class="form-select" v-model="sort" @change="getTrainings">
                            <option value="false" selected disabled >Sort by Date</option>
                            <option value="asc">Oldest</option>
                            <option value="desc">Latest</option>
                        </select>
                    </div>
                </div>
                <div class="table-container" v-if="trainings.length > 0">
                    <div class="fullInputs mb-4 pt-3">
                        <div class="twoInputs">
                            <div class="btnInsideInput" v-if="role === 'user'">
                                <input type="text" id="free_search" class="form-control" v-model="search"
                                       placeholder="Search" autocomplete="off"
                                       @input="searchTraining" maxlength="50">

                                <button @click="searchBackEndHandler(isSearch, 1)" ref="buttonSearch">
                                    <img src="../../../assets/images/SearchIcon.png" alt="">
                                </button>
                            </div>
                            <div class="btnInsideInput" v-else>
                                <input type="text" id="free_search" class="form-control" v-model="search"
                                       placeholder="Search" @input="searchTraining">
                            </div>
                            <div class="getStatus">
                                <select id="statusSeacrh" v-model="status" class="form-select" @change="getTrainings">
                                    <option :value="null" disabled selected>Status</option>
                                    <option value="pending">Pending</option>
                                    <option value="running">Running</option>
                                    <option value="ended">Ended</option>
                                </select>
                            </div>
                            <div class="btnSearchAll" :style="role === 'user' ? {display: 'none'}  : {display: 'block'} ">
                                <button id="searchAll" class="form-control" ref="buttonSearch" @click="getTrainings">
                                    <img src="../../../assets/images/SearchIcon.png" alt="">
                                </button>
                            </div>
                        </div>
                        <div class="oneInput">
                            <select id="filter_dates" class="form-select" v-model="sort" @change="getTrainings">
                                <option value="false" selected disabled >Sort by Date</option>
                                <option value="asc">Oldest</option>
                                <option value="desc">Latest</option>
                            </select>
                        </div>
                    </div>
                    <TableComponent :thead="role === 'user' ? theadUser : thead" :tbody="trainings" @sort="SortTraining" :keys="role === 'user' ? keysUser : keys" model="trainings" name="training"
                                    updateUrl="/complete-edit-trainings" :ids="trainings_ids" @update="updateTraining"/>

                    <div class="paginationLink">
                        <pagination :data="laravelData" @pagination-change-page="getTrainings" :limit="3">
                            <template #prev-nav>
                                <span>Previous</span>
                            </template>
                            <template #next-nav>
                                <span>Next</span>
                            </template>
                        </pagination>
                    </div>
                </div>

                <div v-else class="text-center d-flex flex-column justify-content-center align-items-center h-75 m-auto">
                    <div class="mb-4">
                        <h2 v-if="!searchFlag && !statusFlag"  class="">You Don't Have Any Private Trainings Yet</h2>
                        <h2 v-else>No Data</h2>
                    </div>
                    <div>
                        <button class="btn cssBtnCreateCompetition" v-if="permissions.includes('create training')  && (!searchFlag && !statusFlag)" @click.prevent="CreateTraining">Create Training</button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import TableComponent from "../../components/TableComponent";
    import LaravelVuePagination from "laravel-vue-pagination";
    import training from "../../../api-services/training";

    export default {
        name:'private-training',
        components: {
            TableComponent,
            'Pagination': LaravelVuePagination
        },
        async mounted(){
            await this.$store.dispatch('activeTap', 'training');
            this.permissions = this.$store.state.auth.permissions;
            this.role = this.$store.state.auth.user.data.role[0];
            this.getTrainings();

        },
        data(){
            return {
                thead: ['Training Name', 'Type','Date Created' , 'Status'],
                keys:['name' , 'type' , 'start_date' , 'status'],
                theadUser:['Training Name','Date Created' , 'Type','Status'],
                keysUser:['name' , 'end_date' , 'type' , 'status'],
                permissions: [],
                trainings: [],
                filteredArray: [],
                isActive1:false,
                isActive2:false,
                originalTrainings: [],
                laravelData: {},
                error: null,
                search: '',
                category:'',
                score:false,
                searchFlag: false,
                statusFlag:false,
                sort: false,
                status:null,
                status2:false,
                role:''
            }
        },
        methods:{
            CreateTraining(){
                this.$router.push({name: 'create-training'});
            },
            async getTrainings(page=1){
                if (this.status !== null){
                    this.statusFlag = true;
                }
                try{
                    const response = await training.index(this.search  , this.status, this.sort === false ? this.sort = 'asc' : this.sort , page , 'private');
                    if (process.env.VUE_ENV === 'development')
                    console.log(response);
                    this.trainings = response.data.data;
                    this.laravelData = response.data;
                    this.originalTrainings = response.data.data;
                }catch(e){
                    if (process.env.VUE_ENV === 'development')
                    console.log(e);
                    this.error = e;
                }
            },
            async SortTraining(){
                let status = !this.status2;
                this.originalTrainings.sort(function (a, b) {
                    return status ? -(a.id - b.id || a.name.localeCompare(b.name)) : -(b.id - a.id || b.name.localeCompare(a.name));
                });
                this.status2 = status;
            },
            async updateTraining(e){
                let filteredData = this.trainings.filter(function (data) {
                    return data.id != e;
                });
                this.trainings = filteredData;
            },
            searchTraining(e){
                let searchedValue = e.target.value;
                let searchedData = this.originalTrainings.filter((data) => data.name.includes(searchedValue));
                this.trainings = searchedData;
                this.searchFlag = true;
            },
            async searchBackEndHandler(searchFlag = false) {
                let dataLength = this.trainings.length;
                if (searchFlag && dataLength > 0) {
                    await this.getTrainings();
                }
            },
        }
    }
</script>

<style scoped>

    /*.designRowOrga {*/
    /*    display: flex;*/
    /*    flex-direction: row;*/
    /*    justify-content: space-between;*/
    /*    padding: 0px;*/
    /*    margin-bottom: 20px;*/
    /*}*/

    .btnOrganization button {
        background-color: var(--btn-bg-color);
        color: var(--btn-text-color);
        border: none;
        border-radius: 5px;
        justify-content: end;
        align-content: center;
        padding: 10px;
    }

    /*.cssBtnCreateCompetition{*/
    /*    background-color: #E95626;*/
    /*    color: #fff;*/
    /*    border-radius: 10px;*/
    /*    width: 200px;*/
    /*    padding: 10px;*/
    /*}*/
    .cssNoCompetitions{
        padding: 140px;
    }

    /*.btnInsideInput {*/
    /*    display: flex;*/
    /*    flex-direction: row;*/
    /*    border: 1px solid #FFF;*/
    /*    border-radius: 3px;*/
    /*}*/

    /*.btnInsideInput input {*/
    /*    border: none;*/
    /*}*/

    /*.btnInsideInput button {*/
    /*    background-color: #032431;*/
    /*    border: none;*/
    /*}*/

    /*.twoInputs #free_search {*/
    /*    background-color: #032431;*/
    /*    color: #fff;*/
    /*    width: 350px;*/
    /*}*/

    .btnSearchAll #searchAll{
        background-color: #e65c00;
        color:#fff;
        width:45px;
        padding-left: 0px;
        padding-right: 0px;
        border-color: #e65c00;
    }

    .getScore #statusScore{
        background-color: #032431;
        color: #fff;
        width: 350px;
    }

    /*.getStatus #statusSeacrh{*/
    /*    background-color: #032431;*/
    /*    color: #fff;*/
    /*    width: 350px;*/
    /*}*/

    /*.oneInput #filter_dates {*/
    /*    background-color: #032431;*/
    /*    color: #fff;*/
    /*    width: 220px;*/
    /*}*/

    .twoInputs {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        gap: 20px;
    }

    .fullInputs {
        display: flex;
    }

    .fullInputs {
        justify-content: space-between;
    }

    /*.tabcontent {*/
    /*    border: 1px solid #032431;*/
    /*    background-color: #032431;*/
    /*    border-radius: 0 20px 20px 20px;*/
    /*    padding: 23px;*/
    /*}*/
    .tab {
        overflow: hidden;
    }

    /*.tab .tablinks {*/
    /*    background-color: inherit;*/
    /*    color: #fff;*/
    /*    float: left;*/
    /*    border: none;*/
    /*    outline: none;*/
    /*    cursor: pointer;*/
    /*    padding: 14px 16px;*/
    /*    transition: 0.3s;*/
    /*    font-size: 17px;*/
    /*}*/

    /*.tab .tablinks:hover,*/
    /*.tab .tablinks.active {*/
    /*    background-image: linear-gradient(#044D6B, #021A24);*/
    /*    color: #E37450;*/
    /*    border-radius: 10px 10px 0px 0px;*/
    /*}*/

    /*.tabcontent {*/
    /*    display: block;*/
    /*    padding: 30px;*/
    /*    height: 70vh;*/
    /*    border-top: none;*/
    /*    background-image: linear-gradient(#16303a, #021A24);*/
    /*    border-radius: 0 20px 20px 20px;*/
    /*}*/

    .setting-action {
        text-decoration: none;
        cursor: pointer;
        background-color: #E95626;
        border-radius: 10px;
        color: #FFF;
        border-radius: 4px;
        font-weight: 500;
        padding: 12px 55px;
        font-size: 18px;
        height: fit-content;
    }


    .setting-action:hover {
        color: #FFF;
    }

    /* we will explain what these classes do next! */
    .v-enter-active,
    .v-leave-active {
        transition: opacity 0.5s ease;
    }

    .v-enter-from,
    .v-leave-to {
        opacity: 0;
    }

    .back-route {
        text-decoration: none;
        cursor: pointer;
        color: #FFF;
        font-size: 22px;
    }

    .back-route:hover {
        color: #FFF;
    }
</style>